export default __webpack_public_path__ + "static/media/timer.239d9593.svg";